import { map } from 'rxjs/operators/map';
import { FileSerializer } from '../../models';
import ajax from '../../utils/ajax';

class FileService {
  conductorUrl = process.env.REACT_APP_CONDUCTOR_ASSETS_URL || '';
  filesConfigurationPath = '/networkAsset/files';

  /**
    Create a file
    @param {Object} file
    @param {Object} store Redux store
    @returns {Observable} Observable that emits the normalized response
  */
  create = (file, store) => {
    let data = new FormData();
    data.append('file', file, file.name);
    data.append(
      'fileDef',
      new Blob([JSON.stringify(FileSerializer.serialize(file))], {
        type: 'application/json'
      })
    );
    return ajax(
      {
        url: `${this.conductorUrl}${this.filesConfigurationPath}`,
        body: data,
        method: 'POST',
        responseType: 'json'
      },
      store
    ).pipe(map(data => FileSerializer.normalize(data.response)));
  };

  /**
    Get a file
    @param {String} href
    @param {Object} store Redux store
    @returns {Observable} Observable that emits the normalized response
  */
  get = (href, store) => {
    return ajax(
      {
        url: href,
        method: 'GET',
        responseType: 'json'
      },
      store
    ).pipe(map(data => FileSerializer.normalize(data.response)));
  };

  downloadInBrowser = (data, fileName) => {
    const blob = new Blob([data], { type: 'octet/stream' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style = 'display: none';
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  };
}

export default new FileService();



// WEBPACK FOOTER //
// ./src/services/file/index.js